import { z } from 'zod'
import { useSyncedState } from './useSyncedState'

const schema = z.enum(['off', 'prev'])

export type PanelBaseMode = z.infer<typeof schema>

/** Row 15-light: URL-backed raw token (V1 invariant — label render-only). */
export function usePanelBaseState(): [PanelBaseMode, (m: PanelBaseMode) => void] {
  return useSyncedState('panel_base', schema, 'url', 'off')
}
